// extracted by mini-css-extract-plugin
module.exports = {"CompanyInfoRow":"CompanyInfoRow-module--CompanyInfoRow--32o7q","title":"CompanyInfoRow-module--title--2QJGT","description":"CompanyInfoRow-module--description--2AoWG"};